import { selectAuthSession } from '../../auth/store/selectors';
import { selectOngoingCourses, selectPastCourses } from '../../db/courses/selectors';
import { selectHomeActiveTab } from '../../home/store/selectors';
import { HomeTabs } from '../../home/store/types';
import { useAppSelector } from '../../store/hooks';

export interface UseCourseList {
  onClickUnpublishedCourse: (courseId: MongoId, isCreatingProCourse: boolean) => void;
}

const useCourseList = ({ onClickUnpublishedCourse }: UseCourseList) => {
  const session = useAppSelector((state) => selectAuthSession(state))!;

  const activeTab = useAppSelector((state) => selectHomeActiveTab(state));
  const ongoingCourses = useAppSelector((state) => selectOngoingCourses(state));
  const pastCourses = useAppSelector((state) => selectPastCourses(state));

  const courses = activeTab === HomeTabs.ONGOING_COURSES ? ongoingCourses : pastCourses;

  const handleClickUnpublishedCourse = (courseId: MongoId, isCreatingProCourse: boolean) => () => {
    onClickUnpublishedCourse(courseId, isCreatingProCourse);
  };

  return { session, courses, handleClickUnpublishedCourse };
};

export default useCourseList;
